/**
 * Tiny className concatenator. Handles strings, falsy values, and object
 * notation { "is-active": true }. Built-in alternative to clsx/classnames
 * since the admin doesn't need anything more sophisticated.
 *
 *   cn("base", isOpen && "open", { disabled }) → "base open"
 */
export function cn(...inputs) {
  const out = [];
  for (const input of inputs) {
    if (!input) continue;
    if (typeof input === "string") {
      out.push(input);
    } else if (typeof input === "object") {
      for (const [k, v] of Object.entries(input)) {
        if (v) out.push(k);
      }
    }
  }
  return out.join(" ");
}
